// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"PaymentMethodView_fieldset__qJ7JD","label":"PaymentMethodView_label__sbWRL","input":"PaymentMethodView_input__QPsa5","select":"PaymentMethodView_select__u_SJ4"};